module.exports = __webpack_public_path__ + "img/chevron_obscuro.998ba272.svg";